import axios from 'axios';
import config from '@/config/env-constants';


function getProjectId() {
    if (config.currEnv === 'pjl') {
        return `ayun-${config.currEnv}`;
    } else {
        return `ares-${config.currEnv}-app`;
    }
}

export default {

    baseUrl: `https://us-central1-${getProjectId()}.cloudfunctions.net`,

    getStorageLocations(filterBy, view, currUserId) {
        const url = `${this.baseUrl}/getStorageLocations`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy)
        });
    },

    saveStorageLocation(storageLocation, currUserId, currTimeStamp) {
        const url = `${this.baseUrl}/saveStorageLocation`;
        return axios.post(url, {
            currUserId: currUserId,
            currTimeStamp: currTimeStamp,
            storageLocation: JSON.stringify(storageLocation)
        });
    },

}